

















































































































































































































import { Component, Mixins } from 'vue-property-decorator'

import { mask } from 'vue-the-mask'

import { mdiAlert } from '@mdi/js'

import Card from '@/components/layouts/Card.vue'
import SpecialCard from '@/components/layouts/SpecialCard.vue'
import SpecialCard2 from '@/components/layouts/SpecialCard2.vue'
import SpecialDisabledCard from '@/components/layouts/SpecialDisabledCard.vue'
import DisabledCard from '@/components/layouts/DisabledCard.vue'

import { AuthCardInfo } from '@/api'
import { getSpelling } from '@/tools/spelling'

import { cards } from '@/store/modules/cards'
import { points } from '@/store/modules/points/index'
import { security } from '@/store/modules/security'
import { mock } from '@/tools'
import { Alert } from '@/mixins/Alert'

import { noValue } from '@/filters/no-value'
import EmptyMessage from '@/components/lib/EmptyMessage.vue'

type CardStatus = {
  name: string
  color: string
  nextStatus?: number
  btnText?: string
  additionalVerification: boolean
  colorCard?: boolean
}

export const cardStatus: Record<number, CardStatus> = {
  5: {
    name: 'Карта активна',
    color: '#00B894',
    additionalVerification: true,
    nextStatus: 6,
    btnText: 'Отключить',
  },
  6: {
    name: 'Карта отключена',
    color: '#C33E36',
    additionalVerification: false,
    nextStatus: 5,
    btnText: 'Подключить снова',
  },
}

@Component({
  components: { Card, DisabledCard, SpecialCard, SpecialCard2, SpecialDisabledCard, EmptyMessage },
  directives: { mask },
  filters: { noValue },
})
class MainCardsView extends Mixins(Alert) {
  cardsModule = cards.context(this.$store)
  pointsModule = points.context(this.$store)
  securityModule = security.context(this.$store)
  cardStatus = cardStatus

  isLoadingConnect = false
  isLoadingFix: string = null
  isLoadingChangeStatusQR: string = null

  isOpenVerificationDialogQR: string = null

  qrPDFLink = `${process.env.API_PATH}/user/qr/`
  qrLink = `${process.env.API_PATH}/claims/cardQr?qrData=`

  icons = {
    mdiAlert,
  }

  cardInputValues: Record<string, string> = {}
  cardInputErrors: Record<string, string> = {}
  isLoadingResend: Record<string, boolean> = {}

  async applyCardNumber(card: AuthCardInfo) {
    const qrData = card.qrData || ''
    const cardNumber = this.cardInputValues[qrData] || ''
    const cleanedCardNumber = cardNumber.replace(/\s/g, '')

    if (!cleanedCardNumber) {
      this.$set(this.cardInputErrors, qrData, 'Введите номер карты')
      return
    }

    if (cleanedCardNumber.length < 16 || cleanedCardNumber.length > 19) {
      this.$set(this.cardInputErrors, qrData, 'Номер карты должен содержать от 16 до 19 цифр')
      return
    }

    this.$set(this.isLoadingResend, qrData, true)
    this.$set(this.cardInputErrors, qrData, '')

    try {
      await this.cardsModule.actions.resendCard({
        qrData: qrData,
        cardNumber: cleanedCardNumber,
      })

      this.openAlert({
        type: 'success',
        message: 'Номер карты подтвержден',
        duration: 4000,
      })

      this.$set(this.cardInputValues, qrData, '')

      await this.cardsModule.actions.getCardList()
    } catch (error: unknown) {
      const err = error as { body?: { description?: string; message?: string } } | null | undefined
      const errorMessage =
        err?.body?.description || err?.body?.message || 'Введенный номер карты не соответствует номеру карты в системе'
      this.$set(this.cardInputErrors, qrData, errorMessage)
      mock(error)
    } finally {
      this.$set(this.isLoadingResend, qrData, false)
    }
  }

  async checkCardsActive() {
    this.isLoadingConnect = true
    await this.$router.push({ name: 'connect' }).catch(mock)
    this.isLoadingConnect = false
  }

  get totalBonuses(): string {
    return getSpelling(this.pointsModule.state.points, 'балл', 'балла', 'баллов')
  }

  getCardComponent(card: AuthCardInfo): string {
    if (card.status === 5) {
      if (card.cardType === 0) {
        return 'Card'
      }
      if (card.cardType === 1) {
        return 'SpecialCard'
      }
      return 'SpecialCard2'
    } else {
      if (card.cardType === 0) {
        return 'DisabledCard'
      }
      return 'SpecialDisabledCard'
    }
  }

  submitChangeStatus(card: AuthCardInfo) {
    if (this.cardStatus[card.status].additionalVerification) {
      this.isOpenVerificationDialogQR = card.bskNum
      return
    }

    this.changeCardStatus(card)
  }

  async changeCardStatus(card: AuthCardInfo) {
    this.isLoadingChangeStatusQR = card.bskNum

    await this.cardsModule.actions
      .changeCardStatus({
        status: this.cardStatus[card.status].nextStatus,
        bskNum: card.bskNum,
      })
      .catch(mock)
    await this.securityModule.actions.getUser()
    this.isLoadingChangeStatusQR = null
    this.isOpenVerificationDialogQR = null
  }

  async created() {
    await this.pointsModule.actions.getPoints().catch(mock)
    await this.cardsModule.actions.getCardList().catch(mock)
  }
}

export default MainCardsView
